<div #container class="building-scan-viewer"></div>
